import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProductsAdapter {
  private http = inject(HttpClient);

  getVonqJobTitleId(jobTitle: string): Observable<any> {
    if (!jobTitle) return of(null);
    const params = new HttpParams().set('jobTitle', jobTitle);
    return this.http.get(`${environment.apiBaseUrl}/company/vonq/job-title-id`, { params });
  }

  getVonqFacilityId(query: string): Observable<any> {
    if (!query) return of(null);
    const params = new HttpParams().set('query', query);
    return this.http.get(`${environment.apiBaseUrl}/company/vonq/facility-id`, { params });
  }
}
